import createIcon from '../../createIcon';

/**
 * @component @name FlashOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC43NyAzTDMuNSA0LjI3TDguNSA5LjI3VjEzSDExLjVWMjJMMTUuMDggMTUuODZMMTkuMjMgMjBMMjAuNSAxOC43M0w0Ljc3IDNaTTE4LjUgMTBIMTQuNUwxOC41IDJIOC41VjQuMThMMTYuOTYgMTIuNjRMMTguNSAxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlashOff = createIcon('FlashOff', [
  [
    'path',
    {
      d: 'M4.77 3L3.5 4.27L8.5 9.27V13H11.5V22L15.08 15.86L19.23 20L20.5 18.73L4.77 3ZM18.5 10H14.5L18.5 2H8.5V4.18L16.96 12.64L18.5 10Z',
      key: 'zyvcpj',
    },
  ],
]);

export default FlashOff;
